import { render } from "./ImageSelect.vue?vue&type=template&id=04fcb5fc&scoped=true"
import script from "./ImageSelect.vue?vue&type=script&lang=js"
export * from "./ImageSelect.vue?vue&type=script&lang=js"

import "./ImageSelect.vue?vue&type=style&index=0&id=04fcb5fc&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fcb5fc"]])

export default __exports__